export interface SessionPresence {
  userAgent: string;
  browserName: string;
  browserVersion: string;
  operatingSystem: string;
  deviceType: "DESKTOP" | "MOBILE" | "TABLET" | "PDA" | "UNKNOWN";
  deviceName: string;
}

const match = (value: string, pattern: RegExp) => value.match(pattern)?.[1] ?? "";

export function detectSessionPresence(): SessionPresence {
  const ua = navigator.userAgent;
  let browserName = "Navigateur inconnu";
  let browserVersion = "";
  if (/EdgA?\//.test(ua)) {
    browserName = "Microsoft Edge";
    browserVersion = match(ua, /EdgA?\/([\d.]+)/);
  } else if (/CriOS\//.test(ua)) {
    browserName = "Google Chrome";
    browserVersion = match(ua, /CriOS\/([\d.]+)/);
  } else if (/Chrome\//.test(ua)) {
    browserName = "Google Chrome";
    browserVersion = match(ua, /Chrome\/([\d.]+)/);
  } else if (/FxiOS\//.test(ua)) {
    browserName = "Mozilla Firefox";
    browserVersion = match(ua, /FxiOS\/([\d.]+)/);
  } else if (/Firefox\//.test(ua)) {
    browserName = "Mozilla Firefox";
    browserVersion = match(ua, /Firefox\/([\d.]+)/);
  } else if (/Safari\//.test(ua)) {
    browserName = "Safari";
    browserVersion = match(ua, /Version\/([\d.]+)/);
  }

  let operatingSystem = "Système inconnu";
  if (/iPhone|iPad|iPod/.test(ua)) {
    operatingSystem = `iOS ${match(ua, /OS ([\d_]+)/).replaceAll("_", ".")}`.trim();
  } else if (/Android/.test(ua)) {
    operatingSystem = `Android ${match(ua, /Android ([\d.]+)/)}`.trim();
  } else if (/Windows NT/.test(ua)) {
    const version = match(ua, /Windows NT ([\d.]+)/);
    operatingSystem = version === "10.0" ? "Windows 10/11" : `Windows ${version}`;
  } else if (/Mac OS X/.test(ua)) {
    operatingSystem = `macOS ${match(ua, /Mac OS X ([\d_]+)/).replaceAll("_", ".")}`.trim();
  } else if (/Linux/.test(ua)) operatingSystem = "Linux";

  const tablet = /iPad|Tablet|Android(?!.*Mobile)/i.test(ua);
  const mobile = /iPhone|iPod|Android.*Mobile|Mobile/i.test(ua);
  const pda = /Zebra|Honeywell|DataWedge|Datalogic|TC\d{2}|CT\d{2}/i.test(ua);
  const deviceType = pda ? "PDA" : tablet ? "TABLET" : mobile ? "MOBILE" : "DESKTOP";
  const deviceName = pda ? "Terminal PDA" : tablet ? "Tablette" : mobile ? "Téléphone" : "Ordinateur";

  return { userAgent: ua, browserName, browserVersion, operatingSystem,
    deviceType, deviceName };
}
